import { render, staticRenderFns } from "./BookList.vue?vue&type=template&id=5536566a&scoped=true&"
import script from "./BookList.vue?vue&type=script&lang=js&"
export * from "./BookList.vue?vue&type=script&lang=js&"
import style0 from "./BookList.vue?vue&type=style&index=0&id=5536566a&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./BookList.vue?vue&type=style&index=1&id=5536566a&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5536566a",
  null
  
)

export default component.exports